import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, IconButton, Icon } from 'rsuite'
import AttachFilesForm from '../../../../widgets/attachfiles/AttachFilesForm'
import AttachFilesView from '../../../../widgets/attachfiles/AttachFilesView'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../../utils/loading'
import { requiredFiled } from '../../../../utils/ValidatorUtils'
import {
  deleteForm9Attachments,
  downloadForm9Attachments,
  getForm9Attachments,
  updateForm9Attachments,
  uploadForm9Attachments,
} from '../../../../redux/actions/background'
import { cloneDeep } from 'lodash-es'

export default function Form9AttachFilesWidget({ schema: _schema, ...props }) {
  const { isEdit } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(_schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    console.log('reload _schema', _schema)
    setFormSchema(_schema)
  }, [_schema])

  const handleUpdate = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsEditErr()
    try {
      const response = await updateForm9Attachments(projectId, request)
      // console.log('response', response)

      if (response) {
        let _schema = cloneDeep(formSchema)
        _schema.values = response
        setIsEditErr(false)
        setFormSchema(_schema)
        // updateAttachments(response)
      } else {
        setIsEditErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsEditErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpload = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsUploadErr()
    try {
      const response = await uploadForm9Attachments(projectId, request)
      // console.log('response', response)

      if (response) {
        let _schema = cloneDeep(formSchema)
        _schema.values = response
        setFormSchema(_schema)
        setIsUploadErr(false)
        // updateAttachments(response)
      } else {
        setIsUploadErr(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (schema) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError()
    try {
      // console.log('call delete.')
      const status = await deleteForm9Attachments(projectId, schema.id)
      if (status === 200) {
        // console.log('call get.')
        const response = await getForm9Attachments(projectId)
        // console.log('getAttachments response', response)
        let _schema = cloneDeep(formSchema)
        _schema.values = response
        setFormSchema(_schema)
        setIsDeleteError(false)
        // updateAttachments(response)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await downloadForm9Attachments(projectId, fileObj.id)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await downloadForm9Attachments(projectId, fileObj.id)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onUpload = (data) => {
    const file = data[formSchema.name]
    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    handleUpload(formData)
  }

  const onUpdate = (file, newName) => {
    // console.log('onUpdate file', file, 'newName: ', newName)

    file['projectVersionId'] = projectId
    file.label = newName

    // console.log('file', file)
    handleUpdate(file)
  }

  const onDelete = (index) => {
    let datas = [...formSchema.values]
    handleDelete(datas[index])
  }

  return (
    <div>
      {requiredFiled(formSchema.validators, formSchema.label)}
      {isEdit ? (
        <AttachFilesForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          onSubmit={handleSubmit(onUpload)}
          onDelete={onDelete}
          onUpdate={onUpdate}
          onDownload={onDownload}
          onPreview={onPreview}
          // onChangSeqNo={onChangSeqNo}
          isChangSeqNo={false}
          isEditErr={isEditErr}
          isUploadErr={isUploadErr}
          isDeleteError={isDeleteError}
          loading={isLoading}
        />
      ) : (
        <AttachFilesView schema={formSchema} onDownload={onDownload} onPreview={onPreview} />
      )}
    </div>
  )
}
